import { Pipe, PipeTransform } from '@angular/core';

export const NEW_LINE_KATEX = '$\\newline$';

// todo: send all from server in katex format
@Pipe({ name: 'exerciseFormat' })
export class ExerciseFormatPipe implements PipeTransform {
    result: string;

    transform(value: string = ''): string {
        this.result = value;
        const chain = [
            this.handleUnderline.bind(this),
            this.handlePower.bind(this),
            this.handleBottomPower.bind(this),
            this.handleLog.bind(this),
            this.handleSigns.bind(this)
        ];

        return chain.reduce((acc, cb) => cb(acc), this.result);
    }

    private handlePower(value: string): string {
        let sqrt = 2;
        const reg = /(\w+)\*\*\(?([\w+/]+)\)?/;
        const reg_new = /(\w+)\^\(?([\w+/]+)\)?/;
        // tslint:disable-next-line
        const sqrtExecute = reg.exec(value);
        if (sqrtExecute) {
            const last_simbols = Number(sqrtExecute[2][sqrtExecute[2].length - 1]);
            if (!isNaN(last_simbols)) {
                // tslint:disable-next-line
                sqrt = eval(sqrtExecute[2]);
            }
        }
        // tslint:disable-next-line
        const execute = reg.exec(value) || reg_new.exec(value);
        const pow = execute && execute[2];

        if (!pow) {
            return value;
        }

        if (sqrt < 1) {
            const powNumber: string | number = Math.ceil(1 / +sqrt);
            if (powNumber === 2) {
                return value.replace(reg, `$\\sqrt{$1}$$`);
            }
            return value.replace(reg, `$\\sqrt[${powNumber}]{$1}$`);
        }

        return '$' + value.replace(reg, `$1^{$2}`) + '$';
    }

    private handleBottomPower(value: string): string {
        const reg = /(\w+)\_\(?([\w+/]+)\)?/;
        const execute = reg.exec(value);
        // tslint:disable-next-line
        const pow = execute && execute[2];

        if (!pow) {
            return value;
        }

        return '$' + value.replace(reg, `$1_$2`) + '$';
    }

    private handleUnderline(value: string): string {
        const reg = /_{2,}/;
        return value.replace(reg, `$\\rule{.7cm}{0.15mm}$`);
    }

    private handleLog(value: string): string {
        const reg = /log(\d+)?\((\d+),?\s*(\d+)?\)/;
        const execute = reg.exec(value);

        if (!execute) {
            return value;
        }

        // @ts-ignore-start: noUnusedLocals
        const [str, firstBase, val, baseAgain] = execute;
        // @ts-ignore-end
        const base = firstBase || baseAgain;
        if (!!base) {
            return value.replace(reg, `$log_{${base}} ${val}$`);
        } else {
            return value.replace(reg, `$ln ${val}$`);
        }
    }

    private handleSigns(value: string): string {
        const signs = {
            '\\$\\s*=\\s*': ' =\\,$',
            '&minus;': '–',
            '&ndash;': '–',
            '&times;': '*'
        };
        return Object.keys(signs).reduce((acc, key) => this.replaceSign(acc, key, signs[key]), value);
    }

    private replaceSign(value: string, text: string, sign: string): string {
        return value.replace(new RegExp(text, 'gi'), sign);
    }
}
